module.exports = __webpack_public_path__ + "img/fotogenial.c204e288.jpg";